package tech.gensert.portal.web.showcase.reusables

import kotlinext.js.js
import mui.material.CircularProgress
import mui.material.CircularProgressColor
import mui.material.Grid
import mui.system.sx
import react.FC
import web.cssom.JustifyContent
import web.cssom.px

val LoaderComponent = FC {
    Grid {
        sx {
            justifyContent = JustifyContent.center
            marginTop = 320.px
            marginLeft = 650.px
        }
        CircularProgress {
            sx = js {
                color = CircularProgressColor.secondary
            }
            size = 80
            thickness = 4
        }
    }
}
